<template>
<div>
  <div class="columns">
    <div class="column">
      <div class="columns">
        <div class="column">
          <h4 class="title">
            <span class="has-text-secondary">{{ attribute.type.title }}</span><br>
            <span class="help">Last updated {{ attribute.updated_at | asCalendar }}</span>
          </h4>
          <p>{{ attribute.type.description }}</p>
        </div>
      </div>
      
      <div class="box findings-output">
        <attribute-finding-value 
          :value="$castTo(attribute)" 
          :cast-type="attribute.type.cast_type"
          :scraper="attribute.type.scraper"
          :secondary-scrapers="attribute.type.secondary_scrapers"
        />
      </div>

      <div class="columns">
        <div class="column">
          <h3 class="title is-5">Vulnerabilities</h3>
          <div class="box" v-for="finding in attribute.findings" :key="finding.id">
            <div class="columns">
              <div class="column">
                <vulnerable-title class="has-text-weight-bold has-text-secondary" :type="finding.vulnerable_type" :vulnerable="finding.vulnerable"/>
                <vulnerable-description :type="finding.vulnerable_type" :vulnerable="finding.vulnerable"/>
                {{ finding.created_at | asCalendar }}

                <p class="has-text-weight-bold mt-1">Finding</p>
                <p>{{ finding.output }}</p>

                <div v-if="finding.poc && finding.poc.recommendation">
                  <p class="has-text-weight-bold mt-1">Recommendation</p>
                  <p>{{ finding.poc.recommendation }}</p>
                </div>
                
                <div v-if="finding.false_positive" class="mt-1">
                  <p class="has-text-weight-bold">False Positive</p>
                  <p>
                    {{ finding.false_positive.type.description }}
                  </p>
                </div>
              </div>
              <div class="column is-narrow">
                <div class="is-flex justify-between has-text-right flex-column is-fullheight">
                  <action-button v-if="!finding.resolved_at && !finding.false_positive" class="is-small" @click="markAsFalsePositive(finding)">False Positive</action-button>
                  <div>
                    <unresolved v-if="!finding.resolved_at && !finding.false_positive"/>
                    <resolved v-if="finding.resolved_at"/>
                    <false-positive v-if="finding.false_positive"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p v-if="!attribute.findings.length">No vulnerabilities found.</p>
        </div>
      </div>
    </div>
  </div>
</div>  
</template>
<script>
import { mapGetters } from 'vuex'

export default {

  data: () => ({
    loading: true
  }),
  
  beforeCreate() {
    this.$store.dispatch('attribute/loadAttribute', this.$route.params.attribute).then(() => {
      this.loading = false
    })
  },
  
  computed: {
    ...mapGetters('attribute', [
      'attribute'
    ]),
    attributeChanges() {
      return this.attribute.changes.filter(change => change.old !== null)
    }
  }

}
</script>